import { z } from 'zod'

import { AdUnitSizeDTO } from './types/adUnitSizeDTO'

export const adUnitSizeFromDTO = (size: AdUnitSizeDTO): string => {
  if (size === 'fluid') {
    return 'fluid'
  } else if (Array.isArray(size) && size.length === 2) {
    const [width, height] = size

    return `${width}x${height}`
  } else {
    throw Error('Unsupported combination of parameters')
  }
}

export const adUnitSizeToDTO = (size: string): AdUnitSizeDTO => {
  if (size === 'fluid') {
    return 'fluid'
  } else {
    const [width, height] = size.split('x')

    return [parseInt(width), parseInt(height)]
  }
}

export const validateAdUnitSize = (size: string): boolean => /^\d+x\d+$/.test(size)

export const validateAdUnitSizes = (sizes: string[], ctx: z.RefinementCtx): void => {
  sizes.forEach(val => {
    if (val === 'fluid') {
      return
    }

    if (!validateAdUnitSize(val)) {
      ctx.addIssue({
        code: 'custom',
        path: [val],
      })
    }
  })
}
